/**
 * Registro público — CERRADO.
 *
 * Las altas están cerradas mientras no estén las páginas legales y el contrato
 * de encargo del art. 28 RGPD: una empresa que se registrase hoy metería datos
 * de jornada de sus trabajadores sin encargo firmado.
 *
 * El cierre de verdad vive en el backend (`REGISTRATION_OPEN`, 403 en
 * `POST /signup`): esconder la pantalla no cierra un endpoint público. Esto es
 * solo la cara amable.
 *
 * El formulario original está en el historial de git — con el NIF ya incluido.
 * Para reabrir: `git show 7c3166b~1:frontend/src/components/auth/RegistroPage.tsx`
 * y poner `REGISTRATION_OPEN=true` en el entorno del backend.
 */
import { Link } from 'react-router-dom';
import { Icon } from '../ui/Icon';
import { AuthLayout, CARD_SHADOW } from './AuthLayout';

const WAITLIST_URL = 'https://kakuat.com/#lista';

export function RegistroPage() {
  return (
    <AuthLayout>
      <div
        className="w-full max-w-[480px] self-start bg-canvas border border-line-strong rounded-3xl p-8 sm:p-10 text-center animate-rise"
        style={CARD_SHADOW}
      >
        <span className="w-12 h-12 rounded-2xl bg-brand-soft grid place-items-center mx-auto mb-5">
          <Icon name="clock" size={24} strokeWidth={1.8} className="text-brand" />
        </span>

        <h1 className="font-display font-extrabold text-[26px] tracking-tight mb-3">
          Altas cerradas por ahora
        </h1>
        <p className="text-ink-2 text-[15px] leading-relaxed mb-7">
          Estamos terminando de probarlo con un grupo pequeño de empresas. Apúntate a la
          lista de espera y te avisamos en cuanto abramos.
        </p>

        <a
          href={WAITLIST_URL}
          className="inline-flex items-center justify-center gap-2 w-full rounded-2xl bg-brand text-on-brand font-semibold text-[15.5px] px-5 py-3.5 transition-opacity hover:opacity-90"
        >
          Apuntarme a la lista de espera
          <Icon name="arrow-right" size={18} strokeWidth={2} />
        </a>

        <p className="mt-6 text-[14px] text-ink-2">
          ¿Ya tienes cuenta?{' '}
          <Link to="/login" className="text-brand font-semibold underline">
            Entra aquí
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
